module.exports = __webpack_public_path__ + "files/d0b0854903f2ec28cd1d1980ab244a03.png";